// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Row-module-row-2PM2G{display:grid;grid-gap:4px;gap:4px;grid-template-columns:repeat(12, 1fr)}@media(min-width: 480px){.Row-module-row-2PM2G{gap:6px}}@media(min-width: 600px){.Row-module-row-2PM2G{gap:8px}}@media(min-width: 768px){.Row-module-row-2PM2G{gap:10px}}@media(min-width: 960px){.Row-module-row-2PM2G{gap:12px}}@media(min-width: 1070px){.Row-module-row-2PM2G{gap:20px}}@media(min-width: 1280px){.Row-module-row-2PM2G{gap:23px}}@media(min-width: 1920px){.Row-module-row-2PM2G{gap:24px}}", ""]);
// Exports
exports.locals = {
	"row": "Row-module-row-2PM2G"
};
module.exports = exports;
